let loaded = false

/**
 * Loads the official UTMify UTM tracking script.
 * Safe to call multiple times — the script is only injected once.
 */
export function loadUtmify(): void {
  if (loaded || typeof document === 'undefined') return
  loaded = true

  const script = document.createElement('script')
  script.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js'
  script.async = true
  script.defer = true
  script.setAttribute('data-utmify-prevent-xcod-sck', '')
  script.setAttribute('data-utmify-prevent-subids', '')
  document.head.appendChild(script)
}
